import { Slider } from 'antd'
import { SliderTooltipProps } from 'antd/es/slider'
import { useState } from 'react'

type TipsySliderProps = {
  className?: string
  height: number
  defaultValue?: number
  value?: number
  min: number
  max: number
  step: number
  tooltip?: SliderTooltipProps
  disabled?: boolean
  onChange: (val: number) => void
}

const TipsySlider = ({
  className,
  height,
  defaultValue,
  value,
  min,
  max,
  step,
  tooltip = {
    color: 'rgba(255, 255, 255, 0.20)',
    arrow: false,
    overlayInnerStyle: {
      height: '14px',
      minHeight: '14px',
      lineHeight: '11px',
      border: '1px solid rgba(255,255,255,0.4)',
      borderRadius: '100px',
      fontSize: '10px',
      padding: '0 6px',
    },
  },
  disabled = false,
  onChange,
}: TipsySliderProps) => {
  const [openTooltip, setOpenTooltip] = useState<boolean>(false)

  const handleChange = (val: number) => {
    if (!openTooltip) {
      setOpenTooltip(true)
    }
    onChange?.(val)
  }
  const handleChangeCompleted = () => {
    setTimeout(() => {
      setOpenTooltip(false)
    }, 300)
  }

  return (
    <Slider
      // ref={}
      className={className}
      styles={{
        handle: {
          opacity: 100,
          display: disabled ? 'none' : undefined,
        },
        track: {
          backgroundColor: '#ffffff',
          height: height,
          borderRadius: '9999px',
          transform: 'translateY(-2px)',
        },
        rail: {
          backgroundColor: 'rgba(255, 255, 255, 0.10)',
          height: height,
          transform: 'translateY(-2px)',
        },
      }}
      disabled={disabled}
      tooltip={{ ...tooltip, open: openTooltip }}
      defaultValue={defaultValue}
      min={min}
      max={max}
      step={step}
      onChange={handleChange}
      onChangeComplete={handleChangeCompleted}
      value={value}
    />
  )
}

export default TipsySlider
